{
    "name": "openselves",
    "version": "0.6.2",
    "scripts": {
        "postinstall": "yarn workspace willow-ts install --immutable",
        "dev": "concurrently --kill-others \"cd willow-ts && yarn dev\" \"cd common && yarn dev\" \"cd common-ui && yarn dev\" \"cd client && yarn dev\" \"cd server && yarn dev\" \"cd www && yarn dev\"",
        "clean": "yarn workspaces foreach -Ap run clean",
        "build": "yarn workspaces foreach -Rpt --from \"{client,server,www}\" run build",
        "lint": "yarn build && yarn workspaces foreach -Ap run lint",
        "prepare": "husky"
    },
    "packageManager": "yarn@4.17.1",
    "devDependencies": {
        "concurrently": "^10.0.5",
        "husky": "^9.1.7"
    },
    "workspaces": [
        "willow-ts",
        "common",
        "common-ui",
        "client",
        "server",
        "www"
    ]
}
